import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedNew202601: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_new_202601",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-01-01",
  endDate: "2026-01-31",
  impressions: 34772,
  clicks: 720,
  adsSpendDollars: 1875,
  budgetDollars: 4000,
  salesDollars: 10785,
  bestEstimateRoas: 5.75,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.47,
  newCustomersAcquired: 42,
  dataAvailableAtDate: "2026-02-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
